import AccessoriesRouter from './creative/AccessoriesRouter';
import AngelRouter from './creative/AngelRouter';
import AlbaRouter from './creative/AlbaRouter';
import CreativoRouter from './creative/CreativoRouter';
import CrackerBananaRouter from './creative/CrackerBananaRouter';
import ChocoShakeRouter from './creative/ChocoShakeRouter';
import MontserratRouter from './creative/MontserratRouter';
import MaxiStampsRouter from './creative/MaxiStampsRouter';
import MicroStampsRouter from './creative/MicroStampsRouter';
import MargotRouter from './creative/MargotRouter';

/* eslint-disable */
const ProductList = () => import('../pages/products/ProductList');

export default [
  // Gift cards
  {
    path: '/produit/cadeaux/cartes-cadeaux',
    name: 'coupon',
    component: () => import('../pages/products/coupons/CouponProduct'),
    props: {
      src: require('../../public/img/carte-cadeau-widddi.jpg'),
      type: 'Carte cadeau',
      description:
        "Vous souhaitez offrir un cadeau Widddi à une maman ou des futurs parents mais vous manquez de temps ?<br />Optez pour la carte cadeau imprimable Widddi ! <br /><br />Choisissez le montant, passez commande puis imprimez le pdf que vous recevrez par e-mail. Ajoutez un petit mot sur votre carte cadeau Widddi puis glissez-la dans une jolie enveloppe. <br /><br />Les futurs parents pourront choisir le produit, la couleur et la police d'écriture qu'ils préfèrent.",
      tags: [''],
    },
  },
  {
    path: '/produit/cadeaux/cartes-cadeaux/:code',
    name: 'get-coupon',
    component: () => import('../pages/products/coupons/GetCoupon'),
  },

  // Cooking
  {
    path: '/produit/materiel-creatif',
    name: 'creative-craft',
    component: ProductList,
    props: {
      title: 'Matériel créatif',
      description:
        'Widddi vous accompagnes dans vos projets créatifs avec du matériel unique, fabriqué en petite série et que vous ne trouverez donc pas chez tous vos concurrents ! Offrez-vous une touche d’originalité grâce à la flexibilité de l’impression 3D.',
      tags: ['materiel-creatif'],
      articles: [
        {
          src: require('../../public/img/emporte-piece/emporte-pieces-widddi.jpg'),
          variant: 'Emporte-pièces',
          link: '/produit/materiel-creatif/emporte-piece',
        },
        {
          src: require('../../public/img/emporte-piece/emporte-pieces-sur-mesure.jpg'),
          variant: 'Emporte-pièces sur mesure',
          link: '/produit/materiel-creatif/emporte-piece-sur-mesure',
        },
        {
          src: require('../../public/img/materiel-creatif/vignette-sets-tampons-alphabet.jpg'),
          variant: 'Sets tampon alphabet',
          link: '/produit/materiel-creatif/set-tampon-alphabet',
        },

        {
          src: require('../../public/img/materiel-creatif/maxi-tampons/vignette-maxitampons.jpg'),
          variant: 'Sets de maxi tampons alphabet',
          link: '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet',
        },
        {
          src: require('../../public/img/materiel-creatif/vignette-microtampons.jpg'),
          variant: 'Sets de micro tampons alphabet',
          link: '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet',
        },
        {
          src: require('../../public/img/materiel-creatif/tourninouneur/tourninouneur-widddi.jpg'),
          variant: 'Outils',
          link: '/produit/materiel-creatif/outils/tourninouneur',
        },
      ],
    },
  },
  {
    path: '/produit/materiel-creatif/emporte-piece',
    name: 'cookie-cutters',
    component: ProductList,
    props: {
      title: 'Emporte-pièce',
      description:
        'Chaque emporte-pièce existe en 6 tailles (Mini, XS, S, M, L, XL) pour s’adapter parfaitement à vos besoins.',
      tags: ['emporte-piece'],
      action: 'Choisir la taille',
      articles: [
        {
          src: require('../../public/img/biscuits/ep-alphabet.jpg'),
          name: 'Emporte-pièces',
          variant: 'Alphabet & Chiffres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet',
        },
        {
          src: require('../../public/img/biscuits/alphabet-dosis.jpg'),
          name: 'Emporte-pièces',
          variant: 'Alphabet & Chiffres Dosis',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-planche-a-decouper.jpg'),
          name: 'Emporte-pièce',
          variant: 'Planche à découper',
          link:
            '/produit/materiel-creatif/emporte-piece/planche-a-decouper',
        },
        {
          src: require('../../public/img/biscuits/ep-planche-a-tapas.jpg'),
          name: 'Emporte-pièce',
          variant: 'Planche à tapas',
          link:
            '/produit/materiel-creatif/emporte-piece/planche-a-tapas',
        },
        {
          src: require('../../public/img/biscuits/ep-planche-organique.jpg'),
          name: 'Emporte-pièce',
          variant: 'Planche organique',
          link:
            '/produit/materiel-creatif/emporte-piece/planche-organique',
        },
        {
          src: require('../../public/img/biscuits/ep-planche-zigzag.jpg'),
          name: 'Emporte-pièce',
          variant: 'Planche zigzag',
          link:
            '/produit/materiel-creatif/emporte-piece/planche-zigzag',
        },
        {
          src: require('../../public/img/biscuits/ep-planche-wavy.jpg'),
          name: 'Emporte-pièce',
          variant: 'Planche wavy',
          link:
            '/produit/materiel-creatif/emporte-piece/planche-wavy',
        },
        {
          src: require('../../public/img/biscuits/emporte-piece-coeur-ex-voto-flamme2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur ex voto flamme 2',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-ex-voto-flamme-2',
        },
        {
          src: require('../../public/img/biscuits/ep-flamme.jpg'),
          name: 'Emporte-pièce',
          variant: 'Flamme',
          link:
            '/produit/materiel-creatif/emporte-piece/flamme',
        },
        {
          src: require('../../public/img/biscuits/ep-ailes.jpg'),
          name: 'Emporte-pièce',
          variant: 'Ailes',
          link:
            '/produit/materiel-creatif/emporte-piece/ailes',
        },
        {
          src: require('../../public/img/biscuits/emporte-piece-coeur-ex-voto-ailes.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur ex voto ailes',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-ex-voto-ailes',
        },
        {
          src: require('../../public/img/biscuits/emporte-piece-coeur-ex-voto-feuillage.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur ex voto feuillage',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-ex-voto-feuillage',
        },
        {
          src: require('../../public/img/biscuits/emporte-piece-coeur-ex-voto-flamme.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur ex voto flamme',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-ex-voto-flamme',
        },
        {
          src: require('../../public/img/biscuits/ep-etoile-2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Etoile 2',
          link:
            '/produit/materiel-creatif/emporte-piece/etoile-2',
        },
        {
          src: require('../../public/img/biscuits/ep-etoile-3.jpg'),
          name: 'Emporte-pièce',
          variant: 'Etoile 3',
          link:
            '/produit/materiel-creatif/emporte-piece/etoile-3',
        },
        {
          src: require('../../public/img/biscuits/ep-houx.jpg'),
          name: 'Emporte-pièce',
          variant: 'Houx',
          link:
            '/produit/materiel-creatif/emporte-piece/houx',
        },
        {
          src: require('../../public/img/biscuits/ep-rond.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rond',
          link:
            '/produit/materiel-creatif/emporte-piece/rond',
        },
        {
          src: require('../../public/img/biscuits/ep-croix-1.jpg'),
          name: 'Emporte-pièce',
          variant: 'Croix',
          link:
            '/produit/materiel-creatif/emporte-piece/croix-1',
        },
        {
          src: require('../../public/img/biscuits/ep-croix-2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Croix 2',
          link:
            '/produit/materiel-creatif/emporte-piece/croix-2',
        },
        {
          src: require('../../public/img/biscuits/ep-tartine.jpg'),
          name: 'Emporte-pièce',
          variant: 'Tartine',
          link:
            '/produit/materiel-creatif/emporte-piece/tartine',
        },
        {
          src: require('../../public/img/biscuits/ep-croissant.jpg'),
          name: 'Emporte-pièce',
          variant: 'Croissant',
          link:
            '/produit/materiel-creatif/emporte-piece/croissant',
        },
        {
          src: require('../../public/img/biscuits/ep-coquillage.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coquillage',
          link:
            '/produit/materiel-creatif/emporte-piece/coquillage',
        },
        {
          src: require('../../public/img/biscuits/ep-oiseau.jpg'),
          name: 'Emporte-pièce',
          variant: 'Oiseau',
          link:
            '/produit/materiel-creatif/emporte-piece/oiseau',
        },
        {
          src: require('../../public/img/biscuits/ep-soleil.jpg'),
          name: 'Emporte-pièce',
          variant: 'Soleil',
          link:
            '/produit/materiel-creatif/emporte-piece/soleil',
        },
        {
          src: require('../../public/img/biscuits/ep-soleil2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Soleil 2',
          link:
            '/produit/materiel-creatif/emporte-piece/soleil-2',
        },
        {
          src: require('../../public/img/biscuits/ep-lune.jpg'),
          name: 'Emporte-pièce',
          variant: 'Lune',
          link:
            '/produit/materiel-creatif/emporte-piece/lune',
        },
        {
          src: require('../../public/img/biscuits/ep-nuage.jpg'),
          name: 'Emporte-pièce',
          variant: 'Nuage',
          link:
            '/produit/materiel-creatif/emporte-piece/nuage',
        },

        {
          src: require('../../public/img/biscuits/ep-etoile.jpg'),
          name: 'Emporte-pièce',
          variant: 'Étoile',
          link:
            '/produit/materiel-creatif/emporte-piece/etoile',
        },
        {
          src: require('../../public/img/biscuits/ep-arc-en-ciel.jpg'),
          name: 'Emporte-pièce',
          variant: 'Arc-en-ciel',
          link:
            '/produit/materiel-creatif/emporte-piece/arc-en-ciel',
        },
        {
          src: require('../../public/img/biscuits/ep-arc-en-ciel2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Arc-en-ciel 2',
          link:
            '/produit/materiel-creatif/emporte-piece/arc-en-ciel-2',
        },
        {
          src: require('../../public/img/biscuits/ep-monstera.jpg'),
          name: 'Emporte-pièce',
          variant: 'Monstera',
          link:
            '/produit/materiel-creatif/emporte-piece/monstera',
        },
        {
          src: require('../../public/img/biscuits/ep-feuille.jpg'),
          name: 'Emporte-pièce',
          variant: 'Feuille',
          link:
            '/produit/materiel-creatif/emporte-piece/feuille',
        },
        {
          src: require('../../public/img/biscuits/ep-trefle.jpg'),
          name: 'Emporte-pièce',
          variant: 'Trefle',
          link:
            '/produit/materiel-creatif/emporte-piece/trefle',
        },
        {
          src: require('../../public/img/biscuits/ep-fleur-1.jpg'),
          name: 'Emporte-pièce',
          variant: 'Fleur 1',
          link:
            '/produit/materiel-creatif/emporte-piece/fleur-1',
        },
        {
          src: require('../../public/img/biscuits/ep-fleur-2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Fleur 2',
          link:
            '/produit/materiel-creatif/emporte-piece/fleur-2',
        },
        {
          src: require('../../public/img/biscuits/ep-fleur4.jpg'),
          name: 'Emporte-pièce',
          variant: 'Fleur 4',
          link:
            '/produit/materiel-creatif/emporte-piece/fleur-4',
        },
        {
          src: require('../../public/img/biscuits/ep-maison.jpg'),
          name: 'Emporte-pièce',
          variant: 'Maison',
          link:
            '/produit/materiel-creatif/emporte-piece/maison',
        },
        {
          src: require('../../public/img/biscuits/ep-coeur.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur',
        },
        {
          src: require('../../public/img/biscuits/ep-coeur2.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur 2',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-2',
        },
        {
          src: require('../../public/img/biscuits/ep-coeur-festonne.jpg'),
          name: 'Emporte-pièce',
          variant: 'Coeur festonné',
          link:
            '/produit/materiel-creatif/emporte-piece/coeur-festonne',
        },

        {
          src: require('../../public/img/biscuits/ep-bouche.jpg'),
          name: 'Emporte-pièce',
          variant: 'Bouche',
          link:
            '/produit/materiel-creatif/emporte-piece/bouche',
        },
        {
          src: require('../../public/img/biscuits/ep-chat.jpg'),
          name: 'Emporte-pièce',
          variant: 'Chat',
          link:
            '/produit/materiel-creatif/emporte-piece/chat',
        },
        {
          src: require('../../public/img/biscuits/ep-ours.jpg'),
          name: 'Emporte-pièce',
          variant: 'Ours',
          link:
            '/produit/materiel-creatif/emporte-piece/ours',
        },
        {
          src: require('../../public/img/biscuits/ep-renard.jpg'),
          name: 'Emporte-pièce',
          variant: 'Renard',
          link:
            '/produit/materiel-creatif/emporte-piece/renard',
        },
        {
          src: require('../../public/img/biscuits/ep-tipi.jpg'),
          name: 'Emporte-pièce',
          variant: 'Tipi',
          link:
            '/produit/materiel-creatif/emporte-piece/tipi',
        },
        {
          src: require('../../public/img/biscuits/ep-biche.png'),
          name: 'Emporte-pièce',
          variant: 'Biche',
          link:
            '/produit/materiel-creatif/emporte-piece/biche',
        },
        {
          src: require('../../public/img/biscuits/ep-baleine.jpg'),
          name: 'Emporte-pièce',
          variant: 'Baleine',
          link:
            '/produit/materiel-creatif/emporte-piece/baleine',
        },
        {
          src: require('../../public/img/biscuits/ep-body.jpg'),
          name: 'Emporte-pièce',
          variant: 'Body de bébé',
          link:
            '/produit/materiel-creatif/emporte-piece/body',
        },
        {
          src: require('../../public/img/biscuits/ep-montgolfiere.jpg'),
          name: 'Emporte-pièce',
          variant: 'Montgolfière',
          link:
            '/produit/materiel-creatif/emporte-piece/montgolfiere',
        },
        {
          src: require('../../public/img/biscuits/ep-fanion.jpg'),
          name: 'Emporte-pièce',
          variant: 'Fanion',
          link:
            '/produit/materiel-creatif/emporte-piece/fanion',
        },
        {
          src: require('../../public/img/biscuits/ep-couronne.jpg'),
          name: 'Emporte-pièce',
          variant: 'Couronne',
          link:
            '/produit/materiel-creatif/emporte-piece/couronne',
        },
        {
          src: require('../../public/img/biscuits/ep-diamant.jpg'),
          name: 'Emporte-pièce',
          variant: 'Diamant',
          link:
            '/produit/materiel-creatif/emporte-piece/diamant',
        },
        {
          src: require('../../public/img/biscuits/ep-cristal.jpg'),
          name: 'Emporte-pièce',
          variant: 'Cristal',
          link:
            '/produit/materiel-creatif/emporte-piece/cristal',
        },
        {
          src: require('../../public/img/biscuits/ep-panneau-1.png'),
          name: 'Emporte-pièce',
          variant: 'Panneau',
          link:
            '/produit/materiel-creatif/emporte-piece/panneau-1',
        },
        {
          src: require('../../public/img/biscuits/ep-arche.jpg'),
          name: 'Emporte-pièce',
          variant: 'Arche',
          link:
            '/produit/materiel-creatif/emporte-piece/arche',
        },
        {
          src: require('../../public/img/biscuits/ep-carre-coins-casses.jpg'),
          name: 'Emporte-pièce',
          variant: 'Carré coins cassés',
          link:
            '/produit/materiel-creatif/emporte-piece/carre-coins-casses',
        },
        {
          src: require('../../public/img/biscuits/ep-oval.jpg'),
          name: 'Emporte-pièce',
          variant: 'Oval',
          link:
            '/produit/materiel-creatif/emporte-piece/oval',
        },
        {
          src: require('../../public/img/biscuits/ep-rectangle-4angles-arrondis.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rectangle angles arrondis',
          link:
            '/produit/materiel-creatif/emporte-piece/rectangle-4angles-arrondis',
        },
        {
          src: require('../../public/img/biscuits/ep-rectangle-1angle-arrondi.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rectangle 1 angle arrondi',
          link:
            '/produit/materiel-creatif/emporte-piece/rectangle-1angle-arrondi',
        },
        {
          src: require('../../public/img/biscuits/ep-rectangle-2angles-arrondis.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rectangle 2 angles arrondis',
          link:
            '/produit/materiel-creatif/emporte-piece/rectangle-2angles-arrondis',
        },
        {
          src: require('../../public/img/biscuits/ep-rectangle-gonfle.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rectangle gonflé',
          link:
            '/produit/materiel-creatif/emporte-piece/rectangle-gonfle',
        },
        {
          src: require('../../public/img/biscuits/ep-hexagone.jpg'),
          name: 'Emporte-pièce',
          variant: 'Hexagone',
          link:
            '/produit/materiel-creatif/emporte-piece/hexagone',
        },
        {
          src: require('../../public/img/biscuits/ep-amande.jpg'),
          name: 'Emporte-pièce',
          variant: 'Amande',
          link:
            '/produit/materiel-creatif/emporte-piece/amande',
        },
        {
          src: require('../../public/img/biscuits/ep-carre-wavy.jpg'),
          name: 'Emporte-pièce',
          variant: 'Carré Wavy',
          link:
            '/produit/materiel-creatif/emporte-piece/carre-wavy',
        },
        {
          src: require('../../public/img/biscuits/ep-carre-festonne.jpg'),
          name: 'Emporte-pièce',
          variant: 'Carré festonné',
          link:
            '/produit/materiel-creatif/emporte-piece/carre-festonne',
        },
        {
          src: require('../../public/img/biscuits/ep-rectangle-festonne.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rectangle festonné',
          link:
            '/produit/materiel-creatif/emporte-piece/rectangle-festonne',
        },
        {
          src: require('../../public/img/biscuits/ep-rond-festonne.jpg'),
          name: 'Emporte-pièce',
          variant: 'Rond festonné',
          link:
            '/produit/materiel-creatif/emporte-piece/rond-festonne',
        },
        {
          src: require('../../public/img/biscuits/ep-baroque.jpg'),
          name: 'Emporte-pièce',
          variant: 'Baroque',
          link:
            '/produit/materiel-creatif/emporte-piece/baroque',
        },
        {
          src: require('../../public/img/biscuits/ep-cadre.jpg'),
          name: 'Emporte-pièce',
          variant: 'Cadre',
          link:
            '/produit/materiel-creatif/emporte-piece/cadre',
        },
        {
          src: require('../../public/img/biscuits/ep-fleche.png'),
          name: 'Emporte-pièce',
          variant: 'Fleche',
          link:
            '/produit/materiel-creatif/emporte-piece/fleche',
        },
        {
          src: require('../../public/img/biscuits/ep-etiquette.png'),
          name: 'Emporte-pièce',
          variant: 'Etiquette',
          link:
            '/produit/materiel-creatif/emporte-piece/etiquette',
        },
        {
          src: require('../../public/img/biscuits/ep-sorciere.jpg'),
          name: 'Emporte-pièce',
          variant: 'Chapeau de sorcière',
          link:
            '/produit/materiel-creatif/emporte-piece/chapeau-sorciere',
        },
        {
          src: require('../../public/img/biscuits/ep-chauve-souris.jpg'),
          name: 'Emporte-pièce',
          variant: 'Chauve-souris',
          link:
            '/produit/materiel-creatif/emporte-piece/chauve-souris',
        },
        {
          src: require('../../public/img/biscuits/ep-fantome.jpg'),
          name: 'Emporte-pièce',
          variant: 'Fantôme',
          link:
            '/produit/materiel-creatif/emporte-piece/fantome',
        },
        {
          src: require('../../public/img/biscuits/ep-chene.jpg'),
          name: 'Emporte-pièce',
          variant: 'Feuille de chêne',
          link:
            '/produit/materiel-creatif/emporte-piece/feuille-chene',
        },
        {
          src: require('../../public/img/biscuits/ep-sapin.png'),
          name: 'Emporte-pièce',
          variant: 'Sapin',
          link:
            '/produit/materiel-creatif/emporte-piece/sapin',
        },
        {
          src: require('../../public/img/biscuits/ep-boule-de-noel.png'),
          name: 'Emporte-pièce',
          variant: 'Boule de Noël',
          link:
            '/produit/materiel-creatif/emporte-piece/boule-de-noel',
        },
        {
          src: require('../../public/img/biscuits/ep-flocon.png'),
          name: 'Emporte-pièce',
          variant: 'Flocon',
          link:
            '/produit/materiel-creatif/emporte-piece/flocon',
        },
        {
          src: require('../../public/img/biscuits/ep-bonhomme.png'),
          name: 'Emporte-pièce',
          variant: "Bonhomme en pain d'epice",
          link:
            '/produit/materiel-creatif/emporte-piece/bonhomme',
        },
      ]
    },
  },

  {
    path: '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet',
    name: 'alphabet-cookie-cutters',
    component: ProductList,
    props: {
      title: 'Emporte-pièce Alphabet & Chiffres',
      description:
        'Chaque emporte-pièce existe en 6 tailles (Mini, XS, S, M, L, XL) pour s’adapter parfaitement à vos besoins.',
      tags: ['emporte-piece-alphabet'],
      action: 'Choisir la taille',
      articles: [
        {
          src: require('../../public/img/biscuits/ep-alphabet.jpg'),
          name: 'Emporte-pièce',
          variant: 'set de 26 lettres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/26-lettres',
        },
        {
          src: require('../../public/img/biscuits/ep-0-9.jpg'),
          name: 'Emporte-pièce',
          variant: 'set de chiffres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/chiffres',
        },
        {
          src: require('../../public/img/biscuits/ep-A.jpg'),
          name: 'Emporte-pièce',
          variant: 'A',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/A',
        },
        {
          src: require('../../public/img/biscuits/ep-B.jpg'),
          name: 'Emporte-pièce',
          variant: 'B',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/B',
        },
        {
          src: require('../../public/img/biscuits/ep-C.jpg'),
          name: 'Emporte-pièce',
          variant: 'C',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/C',
        },
        {
          src: require('../../public/img/biscuits/ep-D.jpg'),
          name: 'Emporte-pièce',
          variant: 'D',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/D',
        },
        {
          src: require('../../public/img/biscuits/ep-E.jpg'),
          name: 'Emporte-pièce',
          variant: 'E',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/E',
        },
        {
          src: require('../../public/img/biscuits/ep-F.jpg'),
          name: 'Emporte-pièce',
          variant: 'F',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/F',
        },
        {
          src: require('../../public/img/biscuits/ep-G.jpg'),
          name: 'Emporte-pièce',
          variant: 'G',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/G',
        },
        {
          src: require('../../public/img/biscuits/ep-H.jpg'),
          name: 'Emporte-pièce',
          variant: 'H',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/H',
        },
        {
          src: require('../../public/img/biscuits/ep-I.jpg'),
          name: 'Emporte-pièce',
          variant: 'I',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/I',
        },
        {
          src: require('../../public/img/biscuits/ep-J.jpg'),
          name: 'Emporte-pièce',
          variant: 'J',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/J',
        },
        {
          src: require('../../public/img/biscuits/ep-K.jpg'),
          name: 'Emporte-pièce',
          variant: 'K',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/K',
        },
        {
          src: require('../../public/img/biscuits/ep-L.jpg'),
          name: 'Emporte-pièce',
          variant: 'L',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/L',
        },
        {
          src: require('../../public/img/biscuits/ep-M.jpg'),
          name: 'Emporte-pièce',
          variant: 'M',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/M',
        },
        {
          src: require('../../public/img/biscuits/ep-N.jpg'),
          name: 'Emporte-pièce',
          variant: 'N',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/N',
        },
        {
          src: require('../../public/img/biscuits/ep-O.jpg'),
          name: 'Emporte-pièce',
          variant: 'O',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/O',
        },
        {
          src: require('../../public/img/biscuits/ep-P.jpg'),
          name: 'Emporte-pièce',
          variant: 'P',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/P',
        },
        {
          src: require('../../public/img/biscuits/ep-Q.jpg'),
          name: 'Emporte-pièce',
          variant: 'Q',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/Q',
        },
        {
          src: require('../../public/img/biscuits/ep-R.jpg'),
          name: 'Emporte-pièce',
          variant: 'R',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/R',
        },
        {
          src: require('../../public/img/biscuits/ep-S.jpg'),
          name: 'Emporte-pièce',
          variant: 'S',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/S',
        },
        {
          src: require('../../public/img/biscuits/ep-T.jpg'),
          name: 'Emporte-pièce',
          variant: 'T',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/T',
        },
        {
          src: require('../../public/img/biscuits/ep-U.jpg'),
          name: 'Emporte-pièce',
          variant: 'U',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/U',
        },
        {
          src: require('../../public/img/biscuits/ep-V.jpg'),
          name: 'Emporte-pièce',
          variant: 'V',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/V',
        },
        {
          src: require('../../public/img/biscuits/ep-W.jpg'),
          name: 'Emporte-pièce',
          variant: 'W',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/W',
        },
        {
          src: require('../../public/img/biscuits/ep-X.jpg'),
          name: 'Emporte-pièce',
          variant: 'X',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/X',
        },
        {
          src: require('../../public/img/biscuits/ep-Y.jpg'),
          name: 'Emporte-pièce',
          variant: 'Y',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/Y',
        },
        {
          src: require('../../public/img/biscuits/ep-Z.jpg'),
          name: 'Emporte-pièce',
          variant: 'Z',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/Z',
        },
        {
          src: require('../../public/img/biscuits/ep-0.jpg'),
          name: 'Emporte-pièce',
          variant: '0',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/0',
        },
        {
          src: require('../../public/img/biscuits/ep-1.jpg'),
          name: 'Emporte-pièce',
          variant: '1',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/1',
        },
        {
          src: require('../../public/img/biscuits/ep-2.jpg'),
          name: 'Emporte-pièce',
          variant: '2',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/2',
        },
        {
          src: require('../../public/img/biscuits/ep-3.jpg'),
          name: 'Emporte-pièce',
          variant: '3',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/3',
        },
        {
          src: require('../../public/img/biscuits/ep-4.jpg'),
          name: 'Emporte-pièce',
          variant: '4',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/4',
        },
        {
          src: require('../../public/img/biscuits/ep-5.jpg'),
          name: 'Emporte-pièce',
          variant: '5',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/5',
        },
        {
          src: require('../../public/img/biscuits/ep-6-9.jpg'),
          name: 'Emporte-pièce',
          variant: '6',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/6',
        },
        {
          src: require('../../public/img/biscuits/ep-7.jpg'),
          name: 'Emporte-pièce',
          variant: '7',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/7',
        },
        {
          src: require('../../public/img/biscuits/ep-8.jpg'),
          name: 'Emporte-pièce',
          variant: '8',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/8',
        },
        {
          src: require('../../public/img/biscuits/ep-&.jpg'),
          name: 'Emporte-pièce',
          variant: '&',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/&',
        },
      ]
    },
  },

  {
    path: '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis',
    name: 'alphabet-cookie-cutters-dosis',
    component: ProductList,
    props: {
      title: 'Emporte-pièce Alphabet & Chiffres',
      description:
        'Chaque emporte-pièce existe en 6 tailles (Mini, XS, S, M, L, XL) pour s’adapter parfaitement à vos besoins.',
      tags: ['emporte-piece-alphabet-dosis'],
      action: 'Choisir la taille',
      articles: [
        {
          src: require('../../public/img/biscuits/alphabet-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'set de 26 lettres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/26-lettres-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-0-9-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'set de chiffres',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/chiffres-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-A-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'A',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/A-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-B-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'B',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/B-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-C-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'C',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/C-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-D-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'D',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/D-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-E-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'E',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/E-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-F-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'F',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/F-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-G-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'G',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/G-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-H-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'H',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/H-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-I-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'I',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/I-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-J-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'J',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/J-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-K-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'K',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/K-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-L-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'L',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/L-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-M-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'M',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/M-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-N-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'N',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/N-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-O-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'O',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/O-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-P-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'P',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/P-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-Q-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'Q',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/Q-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-R-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'R',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/R-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-S-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'S',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/S-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-T-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'T',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/T-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-U-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'U',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/U-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-V-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'V',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/V-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-W-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'W',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/W-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-X-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'X',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/X-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-Y-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'Y',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/Y-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-Z-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: 'Z',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/Z-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-0-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '0',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/0-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-1-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '1',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/1-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-2-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '2',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/2-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-3-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '3',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/3-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-4-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '4',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/4-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-5-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '5',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/5-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-6-9-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '6',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/6-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-7-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '7',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/7-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-8-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '8',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/8-dosis',
        },
        {
          src: require('../../public/img/biscuits/ep-&-dosis.jpg'),
          name: 'Emporte-pièce',
          variant: '&',
          link:
            '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/&-dosis',
        },
      ]
    },
  },

  {
    path: '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet-dosis/:name',
    name: 'cookie-cutter-dosis',
    component: () => import('../pages/products/cooking/CookieCutterAlphabet'),
    props: (route) => ({
      // src: require('../../public/img/biscuits/emporte-pieces.jpg'),
      type: 'Emporte-pièce',
      hiddenType: 'cookie-cutter',
      description:
        `Choisissez la taille de votre emporte-pièce parmi les 6 tailles disponibles (mini - XS - S - M - L- XL).`,
      tags: [`emporte-piece-${route.params.name}`],
    }),
  },

  {
    path: '/produit/materiel-creatif/emporte-piece/emporte-piece-alphabet/:name',
    name: 'cookie-cutter-alphabet',
    component: () => import('../pages/products/cooking/CookieCutterAlphabet'),
    props: (route) => ({
      // src: require('../../public/img/biscuits/emporte-pieces.jpg'),
      type: 'Emporte-pièce',
      hiddenType: 'cookie-cutter',
      description:
        `Choisissez la taille de votre emporte-pièce parmi les 6 tailles disponibles (mini - XS - S - M - L- XL).`,
      tags: [`emporte-piece-${route.params.name}`],
    }),
  },

  {
    path: '/produit/materiel-creatif/emporte-piece/:name',
    name: 'cookie-cutter',
    component: () => import('../pages/products/cooking/CookieCutter'),
    props: (route) => ({
      // src: require('../../public/img/biscuits/emporte-pieces.jpg'),
      type: 'Emporte-pièce',
      hiddenType: 'cookie-cutter',
      description:
        `Choisissez la taille de votre emporte-pièce parmi les 6 tailles disponibles (mini - XS - S - M - L- XL).`,
      tags: [`emporte-piece-${route.params.name}`],
    }),
  },

  // Alphabet Stamps
  {
    path: '/produit/materiel-creatif/set-tampon-alphabet',
    name: 'alphabet-stamps',
    component: ProductList,
    props: {
      title: 'Sets de tampons alphabet',
      description:
        "Widddi te permet de composer ton propre coffret de tampons alphabet, ultra pratique et polyvalent.<br/> Des tampons faciles à organiser, à ranger, à utiliser pour une efficacité maximum. <br/> Un grand choix de polices d'écritures, 5 tailles, une optimisation des accessoires pour une grande compatiblité et une utilisation durable et créative.<br/>  Le meilleur des 2 mondes, les sets de tampons alphabet Widddi peuvent s’utiliser avec des réglettes d’alignement simples ou doubles, pour un tamponnage bien droit et rapide. Ou avec des pinces à lettre super pratiques, pour un tamponnage lettre par lettre facile et créatif. <br /><br /> <a href=\"/doc/taille-reelle.pdf\" target=\"_blank\" filename=\"taille-reelle.pdf\" download>Télécharge ce pdf et imprime-le à l'échelle 100% pour voir chaque police en taille réelle.</a>",
      tags: ['set-tampon-alphabet'],
      articles: [
        {
          src: require('../../public/img/materiel-creatif/margot/margot-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Margot',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-margot',
        },
        {
          src: require('../../public/img/materiel-creatif/angel/angel-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Angel',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-angel',
        },
        {
          src: require('../../public/img/materiel-creatif/alba/alba-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Alba',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-alba',
        },
        {
          src: require('../../public/img/materiel-creatif/creativo/creativo-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Creativo',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-creativo',
        },
        {
          src: require('../../public/img/materiel-creatif/cracker-banana/cracker-banana-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Cracker Banana',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-cracker-banana',
        },
        {
          src: require('../../public/img/materiel-creatif/choco-shake/choco-shake-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Choco Shake',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake',
        },
        {
          src: require('../../public/img/materiel-creatif/montserrat/montserrat-vignette.jpg'),
          name: 'Set de tampons alphabet',
          variant: 'Montserrat',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat',
        },
        {
          src: require('../../public/img/materiel-creatif/maxi-tampons/vignette-maxitampons.jpg'),
          name: '',
          variant: 'Sets de maxi tampons alphabet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-maxi-tampon-alphabet',
        },
        {
          src: require('../../public/img/materiel-creatif/vignette-microtampons.jpg'),
          name: '',
          variant: 'Sets de micro tampons alphabet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-micro-tampon-alphabet',
        },
        {
          src: require('../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },

  ...MargotRouter,
  ...AngelRouter,
  ...AlbaRouter,
  ...CreativoRouter,
  ...CrackerBananaRouter,
  ...ChocoShakeRouter,
  ...MontserratRouter,
  ...MaxiStampsRouter,
  ...MicroStampsRouter,
  ...AccessoriesRouter,

  // Tourninouneur
  {
    path:
      '/produit/materiel-creatif/outils/tourninouneur',
    name: 'tourninouneur',
    component: () => import('../pages/products/creative/tools/Tourninouneur'),
    props: {
      src: require('../../public/img/materiel-creatif/tourninouneur/tourninouneur-widddi.jpg'),
      type: "Outil de traçage de cercles",
      hiddenType: 'tourninouneur',
      description:
        'L’outil de traçage de cercle, aussi appelé Tourninouneur, te permet de découper des cercles parfaits de 5 à 30cm de diamètre.',
      tags: ['tourninouneur'],
    },
  },

  // Emporte pièce personnalisé
  {
    path:
      '/produit/materiel-creatif/emporte-piece-sur-mesure',
    name: 'custom-cutters',
    component: () => import('../pages/products/creative/cutters/CustomCutters'),
    props: {
      src: require('../../public/img/emporte-piece/emporte-pieces-sur-mesure.jpg'),
      type: 'Emporte-pièces sur mesure',
      hiddenType: 'custom-cutters',
      description:
        'Je réalise tes emporte-pièces, selon tes propres croquis. Sélectionne le nombre d’emporte-pièces sur mesure que tu souhaites réaliser puis envoye-moi tes croquis par mail à widddi3d@gmail.com avec ton numéro de commande. <br />Un minimum de 7 emporte-pièces sur mesure est demandé pour pouvoir passer commande.',
      tags: ['emporte-piece-sur-mesure'],
    },
  },
];
